module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_9006.52dd647e.png";